import { tvpil } from '../../compat/tvpil';
import { RhinoImageRatio } from '../../image';

const DEFAULT_16x9 = '16x9';

type ChannelIconSettings = {
  channelIconRatio: RhinoImageRatio;
  channelIconType: number | undefined;
};

export function getChannelIconSettings(channelPresentationImageType: number | undefined): ChannelIconSettings {
  const channelIconType = channelPresentationImageType ?? tvpil.getTypeByTypeName(DEFAULT_16x9)?.id;

  const channelIconRatio =
    tvpil.imageTypes.find((type) => type.id === channelIconType)?.ratio ?? (DEFAULT_16x9 as RhinoImageRatio);

  return {
    channelIconRatio,
    channelIconType,
  };
}
